export class ViewControls {
  constructor(
    public pageSize: number,
    public pageIndex: number,
    public totalItems: number,
    public pageSizeOptions: number[]) {
    if (pageSizeOptions.length === 0) pageSizeOptions = [25,50,100];
  }
}